import { useRef, useState } from 'react';
import { useThrottledCallback } from 'use-debounce';

import { useAppSelector } from '@/redux/hooks';
import { getInitialWidth } from '@/redux/modules/windowSize';

import useWindowUpdateHelper from './useWindowUpdateHelper';

type WindowSize = {
    height: number;
    width: number;
};

const useWindowSize = (initialSSRWidth?: number): WindowSize => {
    const initialWidth = useAppSelector(getInitialWidth);
    const effectiveInitialWidth = initialSSRWidth ?? initialWidth ?? 768;

    const [, setWindowSize] = useState<object>();
    const windowSize = useRef<WindowSize>({
        height: 1100,
        width: effectiveInitialWidth,
    });

    const handleResize = useThrottledCallback(
        () => {
            windowSize.current = {
                height: window.innerHeight,
                width: window.innerWidth,
            };
            setWindowSize({});
        },
        200,
        { trailing: true }
    );

    useWindowUpdateHelper(handleResize);

    return windowSize.current;
};

export default useWindowSize;
